import React from "react";
import PropTypes from 'prop-types';
import Icon from './icon';

import '../css/chip.less';

const chipClick = (props) => (e) => {
    const { onRemove, onClick } = props;
    if (onRemove) {
        onRemove(e);
    }
    if(onClick){
        onClick(e)
    }
}

/**
 * Component used to reduce the number of items shown in a list of results, 
 * users can select one or multiple at a time.
 */
function Chip(props) {
    const { className, active, type, CustomChip, readOnly, hideIcon, children, ariaLabel } = props;
    const containerClass = `chip-container ${type}${!readOnly ? ' editable' : ''}${active ? ' active' : ''}${className ? ' ' + className : ''}`;
    const chipAriaLabel = ariaLabel || typeof children === 'string' && children;
    if (CustomChip) {
        return <CustomChip className={containerClass} ariaLabel={chipAriaLabel} {...props}>
            {children}
        </CustomChip>
    }
    return (<button className={containerClass} onClick={chipClick(props)} ariaLabel={chipAriaLabel}>
        {children}
        { !readOnly && !hideIcon && active && <Icon name='x' size={20} />}
    </button>);
}

Chip.defaultProps = {
    readOnly: true,
    hideIcon: false,
    type: 'large'
}

Chip.propTypes = {
    /** Set chip active state */
    active: PropTypes.bool,
    /** compare button's text when product is selected */
    className: PropTypes.string,
    /** Change handler for Chips */
    onRemove: PropTypes.func,
    /** Style types */
    type: PropTypes.oneOf(['large', 'small']),
    /** Custom component for chip, for example a Link*/
    CustomChip: PropTypes.func,
    /** Indicate if chips are interactive */
    readOnly: PropTypes.bool,
    /** True if you don't want the close icon for interactive chips */
    hideIcon: PropTypes.bool
}

export default React.memo(Chip);
